import { render, staticRenderFns } from "./c_home_hotranking.vue?vue&type=template&id=24626c93&scoped=true&"
import script from "./c_home_hotranking.vue?vue&type=script&lang=js&"
export * from "./c_home_hotranking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24626c93",
  null
  
)

export default component.exports